// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"sn","imageWrapper":"so","image":"sp","copyrightAndBrandLogo":"sq","brandLogo":"sr","copyright":"ss","rentalBadge":"st"};